import { Component, OnInit } from '@angular/core';
import { Observable, withLatestFrom } from 'rxjs';
import { VerfahrenFacade, VerfahrenResource } from '@schir-int-client/verfahren-shared';
import { ActivatedRoute } from '@angular/router';
import { switchMap, take } from 'rxjs/operators';
import { TitleService } from '../../../../tech/src/lib/title/title.service';
import { AktenzeichenRendererProvider } from '@schir-int-client/aktenzeichen-shared';
import { AdressverwaltungFacade } from '@schir-int-client/adressverwaltung-shared';
import { ApiRootFacade, ApiRootLinkRel } from '@schir-int-client/api-root';
import { getUrl } from '@ngxp/rest';

@Component({
	selector: 'schir-int-client-vorgaenge-in-verfahren-container',
	templateUrl: './vorgaenge-in-verfahren-container.component.html',
	styleUrls: ['./vorgaenge-in-verfahren-container.component.scss'],
	host: { class: 'x-section' },
	standalone: false,
})
export class VorgaengeInVerfahrenContainerComponent implements OnInit {
	verfahren: Observable<VerfahrenResource>;

	constructor(
		private verfahrenFacade: VerfahrenFacade,
		private adressverwaltungFacade: AdressverwaltungFacade,
		private route: ActivatedRoute,
		public titleService: TitleService,
		private aktenzeichenRendererProvider: AktenzeichenRendererProvider,
		apiRootFacade: ApiRootFacade
	) {
		this.verfahren = this.route.params.pipe(
			withLatestFrom(apiRootFacade.getCurrentApiRoot()),
			switchMap(([route, apiRoot]) => {
				verfahrenFacade.loadSingleVerfahren(
					getUrl(apiRoot, ApiRootLinkRel.VERFAHRENS) + '/' + route['verfahrenId']
				);
				return this.verfahrenFacade.verfahrenSingle;
			})
		);
	}

	ngOnInit() {
		this.verfahren.forEach(value => {
			if (value != null) {
				this.titleService.setTitle(this.aktenzeichenRendererProvider.getRenderer().render(value.aktenzeichen));
			}
		});
		// Verbirgt die Ladezeit der Kontakte vor dem Benutzer
		this.adressverwaltungFacade.kontakteBySearch
			.pipe(take(1))
			.subscribe(contacts => console.log('pre-loaded contacts'));
	}

	//switch focus to left or right column by arrow keys
	switchFocus(event: KeyboardEvent) {
		const leftArrow = event.key == 'ArrowLeft';
		const rightArrow = event.key == 'ArrowRight';

		if (leftArrow || rightArrow) {
			const activeParents: HTMLElement[] = this.getVisibleParents();
			const lastIndex = activeParents.length - 1;
			const activeElement = document.activeElement;

			for (const p of activeParents) {
				if (p.contains(activeElement)) {
					let focusIndex;
					let index = activeParents.indexOf(p);

					if (index == 0 && leftArrow) {
						focusIndex = lastIndex;
					} else if (index == lastIndex && rightArrow) {
						focusIndex = 0;
					} else if (leftArrow) {
						focusIndex = --index;
					} else if (rightArrow) {
						focusIndex = ++index;
					}
					(<HTMLElement>activeParents[focusIndex].querySelector('h2')).focus();
				}
			}
		}
	}

	private getVisibleParents(): HTMLElement[] {
		const activeElements = [];
		const prefix = 'schir-int-client-';
		const suffix = [
			'vorgaenge-in-verfahren',
			'verfuegungen-in-vorgang-container',
			'aufgaben-in-verfuegung-container',
			'adressaten-in-aufgabe-container',
			'kontakt-list-container',
		];

		for (const s of suffix) {
			const element: HTMLElement = document.querySelector(prefix + s);
			if (element) {
				activeElements.push(element);
			}
		}
		return activeElements;
	}
}
